import Cookies from 'js-cookie';

const LoggedOut = () => {
  Cookies.remove('account_id');
  Cookies.remove('accessToken');
  Cookies.remove('refreshToken');
};

export default LoggedOut;
